/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of svs (patients) to display or load svs */


(function () {
  'use strict';
  angular.module('vcutils.sv')
    .component('svlist', {
      restrict: 'E',
      bindings: {
        svs: '<?'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>SV Kürzel</th>
            <th>Bezeichnung</th>
            <th>PLZ</th>
            <th>Ort</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="sv in vm.svs">
            <td>{{sv.short}} <span ng-show="sv.old"> ({{sv.old}})</span></td>
            <td>{{sv.name}}</td>
            <td>{{sv.zipcode}}</td>
            <td>{{sv.city}}</td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editSv(sv)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removeSv(sv)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Sv', 'SvHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Sv, SvHelper, vertxEventBusService) {
          let vm = this;
          vm.editSv = SvHelper.editSv;
          vm.removeSv = removeSv;
          
          vm.$onInit = function () {

            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.svs)) {
              vm.svs = Sv.$search({active: true});
            }
          }; // $onInit()
  
  
          function removeSv(sv) {
            sv.active = false;
            sv.$save();
          }
          
          vertxEventBusService.on('svs.update', function (message) {
            $log.debug('debug: SV update received: ', message);
            let messages = message.split(':');
            vm.svs.$refresh().$then(function () {
              $log.debug('debug: svlist refreshed svs');
            }, function (error) {
              $log.debug('debug: svlist refresh svs failed: ', error);
            });
          });
          

          
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());